import Cookies from 'js-cookie'

import { getDomainFromHostname } from '@/utils/route'

const TokenKey = 'PartnerAuthToken'
const v2TokeyKey = `${TokenKey}X`
const domain = getDomainFromHostname()
const cookieDomain = domain ? { domain: `.${domain}`, secure: true } : {}

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token, setV2Token = false) {
  if (!setV2Token) {
    Cookies.set(TokenKey, token)
  }

  return Cookies.set(`${v2TokeyKey}`, token, cookieDomain)
}

export function removeToken() {
  Cookies.remove(TokenKey) // Remove token in current domain

  Cookies.remove(v2TokeyKey) // Remove token in cookie the sub-domain
  Cookies.remove(v2TokeyKey, cookieDomain) // Remove token in cookie the sub-domain. Shared token with PO

  // Removing old cookies for cleanup
  if (Cookies.get('tamara-mp-token')) {
    Cookies.remove('tamara-mp-token')
  }
  if (Cookies.get('v2-tamara-mp-token')) {
    Cookies.remove('v2-tamara-mp-token', cookieDomain)
  }
}
